<template>
  <section class="section">
    <box>
      <div class="columns">
        <div class="column">
          <tabs :theme="$_ui_theme_tabs">
            <tab
              :title="$l('components.configurationUpdate.version', 'Version')"
              hash="version"
            >
              <UpdateVersion> </UpdateVersion>
            </tab>
            <tab
              :title="$l('components.configurationUpdate.product', 'Product')"
              hash="tag"
            >
              <UpdateTag></UpdateTag>
            </tab>
            <tab
              :title="$l('components.configurationUpdate.os', 'OS')"
              hash="os"
            >
              <UpdateOS></UpdateOS>
            </tab>
            <tab
              :title="
                $l(
                  'components.configurationUpdate.repositories',
                  'Repositories'
                )
              "
              hash="repositories"
            >
              <UpdateRepo></UpdateRepo>
            </tab>
          </tabs>
        </div>
      </div>
    </box>
  </section>
</template>

<script>
import UpdateVersion from "@/components/UpdateVersion.vue";
import UpdateTag from "@/components/UpdateTag.vue";
import UpdateOS from "@/components/UpdateOS.vue";
import UpdateRepo from "@/components/UpdateRepo.vue";

import { mapGetters } from "vuex";
import { Tabs, Tab } from "@cyradar/ui";

export default {
  name: "ConfigurationUpdate",
  components: {
    UpdateVersion,
    UpdateTag,
    UpdateOS,
    UpdateRepo,
    Tabs,
    Tab,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["authenticationClaims", "isAdmin", "currentLocale"]),
  },
  methods: {},
  mounted() {},
};
</script>

<style src="vue-select/dist/vue-select.css"></style>

